import { render, staticRenderFns } from "./NoticesTab.vue?vue&type=template&id=4ce0fc05&"
import script from "./NoticesTab.vue?vue&type=script&lang=js&"
export * from "./NoticesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports